export default {
  manageLoyalty: {
    title: 'Rewards Rate',
    description:
      'Every time a member makes a purchase, they will automatically be rewarded with Coins that can be used as payment codes on future purchases. <br /> <br /> Select an option or set a custom value. This can be changed.',
    pageTopic: 'After a purchase, the member will earn:',
    successNotification: 'Loyalty set up successfully',
    titleVideoTutorial:
      '👋 Hey there! Looking for details about rewarding In-Store & Online members?'
  },
  coinImagePage: {
    title: 'Reward Coin Image',
    description:
      'Coins are your rewards currency! <br /> <br /> You choose what your Coin will look like! We recommend your business logo or Social media image so people recognize your brand.',
    imageUpload: {
      cropTitle: 'Logo / Coin Image'
    },
    uploadInstructionLabel: {
      mobile: 'Upload an image',
      desktop: 'Upload or drag and drop an image'
    },
    successNotification: 'Coin updated successfully'
  },
  refundPolicy: {
    title: 'Return Policy',
    description:
      'The Coins will be only activated after your refund period for your protection. <br /> <br /> Select an option or set a custom time.',
    pageTopic: 'Select how many days before Coins are activated:',
    successNotification: 'Refund policy set up successfully'
  },
  coin2dEdit: {
    title: 'My Branded Coin',
    successNotification: 'Coin updated successfully',
    errorImgUpload: 'Unable to upload images, please try again',
    errorReserveInfos:
      'Unable to reserve currency information, please try again',
    errorNameUnavailable:
      'Coin name unavailable. Please, enter another name and try again.'
  }
};
